<template>
  <v-row class="field-indent flex-nowrap mt-2 mb-4">
    <ValidationProvider
      :name="field.name | slugify"
      :rules="rules"
      slim
    >
      <v-checkbox
        v-model="value"
        :input-value="field.defaultValue"
        class="mt-0 mr-2"
      />
    </ValidationProvider>
    <div class="description align-self-center">
      {{ $t('registerScreen.termsAndPrivacyDescription') }}
      <a
        :href="termsUrl"
        target="_blank"
        rel="noopener"
        class="d-block mt-2"
      >
        {{ $t('registerScreen.conditionsOfParticipation') }}
      </a>
      <a
        :href="privacyPolicyUrl"
        target="_blank"
        rel="noopener"
        class="d-block"
      >
        {{ $t('registerScreen.privacyPolicy') }}
      </a>
    </div>
  </v-row>
</template>

<script>
import _ from 'lodash'
import {mapGetters} from 'vuex'
import {resolveUrlPlaceholders} from '@/utils/urlHelpers'

export default {
  name: 'TermsAndPrivacyField',
  props: {
    field: {
      type: Object,
      required: true
    },
    selectedCountry: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: false
    }
  },
  computed: {
    ...mapGetters(['authSettings']),
    rules() {
      return this.field.required ? 'requiredSwitch' : ''
    },
    privacyPolicyUrl() {
      const privacyPolicyFile = _.get(
        this.authSettings, 'privacy_policy_file', '#'
      )
      return resolveUrlPlaceholders(
        privacyPolicyFile,
        {
          custom_fields: [{
            key: 'country',
            value: this.selectedCountry
          }]
        }
      )
    },
    termsUrl() {
      const termsFile = _.get(
        this.authSettings, 'terms_file', '#'
      )
      return resolveUrlPlaceholders(
        termsFile,
        {
          custom_fields: [{
            key: 'country',
            value: this.selectedCountry
          }]
        }
      )
    },
  },
  watch: {
    value(newVal) {
      this.$emit('select', {
        key: this.field.key,
        value: newVal,
        identity: this.field.identity ? this.field.identity : false
      })
    }
  },
  mounted() {
    this.value = this.field.defaultValue
  }
}
</script>
